import { FormikHelpers } from "formik";
import { useContext } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { isTypeOfNodeSearchForm, isTypeOfPhoneLineSearchForm } from "src/components/Common/UI/SydFilter/SydFilterTypeChecker";
import NodeSearchForm from "./NodeSearchForm";

const emptyNodeSearchForm: INodeSearchForm = {
  description: ""
}

const SearchPhoneLines = () => {
  const sydFilterCtx = useContext(SydFilterContext);

  const activeFilters = sydFilterCtx.activeFilters;
  const clearForm = sydFilterCtx.clearAllFilters;
  const saveFilters  = sydFilterCtx.saveFilters;
  const handleClose = sydFilterCtx.toggleFilterVisibility;

  const initialValues = isTypeOfNodeSearchForm(activeFilters) ? activeFilters as INodeSearchForm : emptyNodeSearchForm;

  const handleSubmit = async (values: INodeSearchForm, { setSubmitting }: FormikHelpers<INodeSearchForm>): Promise<void> => {
    saveFilters(values);
    setSubmitting(false);
    handleClose();
  }

  return (
    <NodeSearchForm initialValues={initialValues} onSubmit={handleSubmit} onClearForm={clearForm} />
  )
}

export default SearchPhoneLines;